<template>
  <div class="report">
    <div>
      <p class="title">转运联单</p>
      <p>月份
        <el-date-picker
          v-model="from24.date"
          type="month"
          value-format="yyyy-MM-dd"
          placeholder="选择月">
        </el-date-picker>
      </p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>

      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport24" >打印</el-button>
      </p>
    </div>
  </div>
</template>
<script>
import coder from "./enum.js"
// import power from "./power.js"
// let url={0:"/report/grant",1:"/report/in-out",2:"/report/out",3:"/report/grant1",
//   4:"/report/year",5:"/report/in",6:"/report/month",
//   7:"/report/dangerous",8:"/report/year",9:"/report/month1",10:"/report/dangerous"};

export default {
  name: "Report",
  data(){
    return{
      from24:{
        date:'',
      },
      car_id_options: [],
      car_id_value: '',

      line_num:[],
      line_options: [],
      line_value: '',
      hospitals:[],
      allArea:[],
      driver_options: [],
    }
  },
  mounted(){
    let $this=this;
    // window.ws.AddFunc("S2W_CarAndLineAndDriverRes",function(code,err,cars,lines,drivers){
    //   if (code===coder.OK) {
    //     let carIDs = [];
    //     for(let i=0;i<cars.length;i++){
    //       carIDs.push({value:cars[i],label:cars[i]})
    //     }
    //     $this.car_id_options=carIDs;
    //     // $this.setData({car_id_options:carIDs});
    //
    //     let lineArr = [];
    //     for(let i=0;i<lines.length;i++){
    //       lineArr.push({value:lines[i],label:lines[i]})
    //     }
    //     $this.line_options = lineArr;
    //     // $this.setData({line_options :lineArr});
    //
    //     let driverArr = [];
    //     for(let i=0;i<drivers.length;i++){
    //       driverArr.push({value:drivers[i],label:drivers[i]})
    //     }
    //     $this.driver_options = driverArr
    //     // $this.setData({driver_options:driverArr});
    //   }else{
    //     $this.$alert(err+'('+code+')', '错误', {
    //       confirmButtonText: '确定'
    //     });
    //   }
    // });
    // window.ws.Call("W2S_CarAndLineAndDriver");


    // if (window.hospitals===null||window.hospitals===undefined||window.hospitals.length===0) {
    //   window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
    //     let names = [];
    //     for(let i=0;i<list.length;i++){
    //       names.push({value:list[i],list:list[i]})
    //     }
    //     $this.hospitals=names;
    //     window.hospitals=names;
    //   });
    //   console.log("W2S_GetHospitalNames");
    //   window.ws.Call("W2S_GetHospitalNames");
    // }else{
    //   this.hospitals=window.hospitals
    // }

    // if (window.allArea===null||window.allArea===undefined||window.allArea.length===0){
    //
    //   window.ws.AddFunc("S2W_GetAllAreaRes",function(list){
    //     let names = [];
    //     for(let i=0;i<list.length;i++){
    //       names.push({value:list[i],list:list[i]})
    //     }
    //     $this.allArea=names;
    //     window.allArea=names;
    //   });
    //
    //   window.ws.Call("W2S_GetAllArea")
    // }else{
    //   this.allArea=window.allArea;
    // }
  },
  methods: {
    openReport24(index){
      if (this.from24.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report24Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/dangerous",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report24",this.from24.date);
    },


    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
  }
}
</script>
<style scoped>
.report{
  /*//width: 910px;*/
  text-align: left;
}
.report>div{
  line-height: 5px;
  font-size: 12px;
  display: inline-block;
  width: 400px;
  height: 200px;
  margin-right:15px;
  margin-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ccc;
}
.report>el-button{
  width: 400px;
}
.title{
  font-size: 20px;
}
/*.report>div:last-child{margin-right: 0 !important;}*/
/*.report>div>span{display: block;width: 100%}*/

/*.report>div>span>label:last-child{display: inline-block;text-align: right;width: calc(100% - 60px)}*/
/*.report>div>span>label:first-child{display: inline-block;width: 50px}*/
/*.report>div>div{margin-top: 5px;margin-bottom: 5px;margin-left: 10px}*/


</style>



// WEBPACK FOOTER //
// src/view/myTransport.vue